const zones = (state = [], action) => {
  switch (action.type) {
    case 'SET_ZONES':
      return action.zones;
    default:
      return state;
  }
};

export default zones;
